export class PlanningShiftsFinished {
    admin_shifts_finished: boolean;
}
